import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { SharedEditableInputComponent } from '../shared-input.component';
import { FeedbackService } from '../../../../../core/feedback.service';
import { EditLocationService } from '../../service/edit-location.service';
import { EditLocationLocalStore } from '../../edit-location-local-store.service';
import { EditableTextualInputComponent } from '../editable-textual-input/editable-textual-input.component';
import { MatIcon } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-editable-coordinate-inputs',
    templateUrl: './editable-coordinate-inputs.component.html',
    styleUrls: ['./editable-coordinate-inputs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatIcon,
        EditableTextualInputComponent,
    ],
})
export class EditableCoordinateInputsComponent extends SharedEditableInputComponent implements OnInit {

  @Input() subtype:
      | 'coordinateImport'
      // more to come?
      = 'coordinateImport';

  constructor(protected cd: ChangeDetectorRef,
              protected feedbackService: FeedbackService,
              protected sidePanelService: EditLocationService,
              protected localStore: EditLocationLocalStore) {
    super(cd, feedbackService, sidePanelService, localStore);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

}
